import { render, staticRenderFns } from "./LabelListItem.vue?vue&type=template&id=9ed3afd6&scoped=true&"
import script from "./LabelListItem.vue?vue&type=script&lang=js&"
export * from "./LabelListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed3afd6",
  null
  
)

export default component.exports